export const oauthConfig = {
  clientId: import.meta.env.VITE_REACT_APP_OAUTH_CLIENT_ID || "",
  authorizationEndpoint:
    import.meta.env.VITE_REACT_APP_OAUTH_AUTH_ENDPOINT || "",
  tokenEndpoint: import.meta.env.VITE_REACT_APP_OAUTH_TOKEN_ENDPOINT || "",
  redirectUri: import.meta.env.VITE_REACT_APP_OAUTH_REDIRECT_URI || "",
};
